import { render, staticRenderFns } from "./qy-explain.vue?vue&type=template&id=d1dec240&scoped=true&"
import script from "./qy-explain.vue?vue&type=script&lang=js&"
export * from "./qy-explain.vue?vue&type=script&lang=js&"
import style0 from "./qy-explain.vue?vue&type=style&index=0&id=d1dec240&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dec240",
  null
  
)

export default component.exports